import styled from 'styled-components';

export const StyledButtonRow = styled.div`
  display: flex;

  button,
  a {
    white-space: nowrap;
    text-transform: uppercase;
    margin-right: 20px;
  }
`;
